import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { ProjectsRoutingModule } from "./projects-routing.module";
import { ProjectsComponent } from "./projects.component";
import { TranslateModule } from "@ngx-translate/core";
import { CarouselModule } from 'ngx-bootstrap/carousel';

@NgModule({
  declarations: [ProjectsComponent],
  imports: [CommonModule, ProjectsRoutingModule, TranslateModule.forChild() , CarouselModule.forRoot()  ]
})
export class ProjectsModule {}
